/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {AdapterDateFns} from '@mui/x-date-pickers-pro/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers-pro/LocalizationProvider';
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {TrusstGPTProvider} from './AppProvider';
import {AuthProvider} from './AuthProvider';
import DefaultApiClientProvider from './DefaultApiClientProvider';
import {LaunchDarklyProvider} from './LaunchDarklyProvider';
import {NotificationContextProvider} from './NotificationContextProvider';
import {PromptProvider} from './PromptProvider';
import RuntimeContextProvider from './RuntimeContextProvider';
import {ThemeProvider} from './ThemeProvider';
import {ToastProvider} from './ToastProvider';
import {TrusstedAgentProvider} from './TrusstedAgentProvider';

type Props = {
  children: React.ReactNode;
};

export const Providers = ({children}: Props) => {
  return (
    <RuntimeContextProvider>
      <AuthProvider>
        <LaunchDarklyProvider>
          <BrowserRouter>
            <ThemeProvider>
              <NotificationContextProvider>
                <DefaultApiClientProvider>
                  <TrusstGPTProvider>
                    <PromptProvider>
                      <TrusstedAgentProvider>
                        <ToastProvider>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <>{children}</>
                          </LocalizationProvider>
                        </ToastProvider>
                      </TrusstedAgentProvider>
                    </PromptProvider>
                  </TrusstGPTProvider>
                </DefaultApiClientProvider>
              </NotificationContextProvider>
            </ThemeProvider>
          </BrowserRouter>
        </LaunchDarklyProvider>
      </AuthProvider>
    </RuntimeContextProvider>
  );
};
